/**
 * Force-upgrade responses do not have an active subscription, so Daisy can return
 * feature flags as active with no applied limit. Expired trials should still be
 * treated like trial-to-paid conversions for local plan validation.
 *
 * @param {import('../types').SiteLimits} currentSiteLimits
 * @param {import('../types').BillingData} billingData
 * @returns {import('../types').SiteLimits}
 */
const normalizeForceUpgradeTrialLimits = (currentSiteLimits, billingData) => {
    const isExpiredTrial =
        billingData?.forceUpgradeOwner && billingData?.lastSubscriptionType === 'trial';
    const analyticsLimit = currentSiteLimits?.limitAnalytics;

    if (
        !isExpiredTrial ||
        analyticsLimit?.active !== true ||
        (analyticsLimit?.limit !== null && analyticsLimit?.limit !== undefined)
    ) {
        return currentSiteLimits;
    }

    return {
        ...currentSiteLimits,
        limitAnalytics: {
            ...analyticsLimit,
            limit: true,
        },
    };
};

export default normalizeForceUpgradeTrialLimits;
